import { render, staticRenderFns } from "./AccountForgotView.vue?vue&type=template&id=13e5f148&scoped=true&"
import script from "./AccountForgotView.vue?vue&type=script&lang=js&"
export * from "./AccountForgotView.vue?vue&type=script&lang=js&"
import style0 from "./AccountForgotView.vue?vue&type=style&index=0&id=13e5f148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e5f148",
  null
  
)

/* custom blocks */
import block0 from "./AccountForgotView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports